import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../nav_bar/Navbar";
import axiosInstance from "../../api/axiosInstance";
import "./Support.css"; // 🎨 reuse existing Support styles

const TicketHistory = () => {
 const [tickets, setTickets] = useState([]);
 const [loading, setLoading] = useState(true);
 const [error, setError] = useState("");

 const navigate = useNavigate();

 useEffect(() => {
 const fetchTickets = async () => {
 // Get token from localStorage
 const token = localStorage.getItem("token");

 if (!token) {
 setError("Please login to view your tickets.");
 setLoading(false);
 return;
 }

 // Prepare headers
 const headers = {
 Authorization: `Bearer ${token}`,
 };

 try {
 const res = await axiosInstance.get("/client/support/history", {
 headers,
 });

 
 setTickets(res.data || []);
 } catch (err) {
 
 setError("Failed to load ticket history.");
 } finally {
 setLoading(false);
 }
 };

 fetchTickets();
 }, []);

 return (
 <div className="login-page">
 <Navbar />
 <main className="login-wrapper">
 <div className="form-container">
 <h2>My Support Tickets</h2>
 <p className="subtitle">View and track your support requests</p>

 {loading && <p className="subtitle">Loading tickets...</p>}

 {!loading && error && <p className="support-error">{error}</p>}

 {!loading && !error && tickets.length === 0 && (
 <p className="subtitle">You have not raised any support tickets yet.</p>
 )}

 {!loading && tickets.length > 0 && (
 <div className="ticket-list">
 {tickets.map((ticket) => {
 const ticketId = ticket.ticketId || ticket.id;
 return (
 <div
 key={ticketId}
 className="ticket-item ticket-card"
 onClick={() => navigate(`/support/tickets/${ticketId}`)}
 role="button"
 >
 <div className="ticket-header">
 <span className="ticket-subject">Ticket #{ticketId}</span>
 <span
 className={`ticket-status ${ticket.status
 ?.toLowerCase()
 .replace(" ", "-")}`}
 >
 {ticket.status}
 </span>
 </div>
 <p className="ticket-preview">
 {ticket.message?.length > 100
 ? ticket.message.slice(0, 100) + "..."
 : ticket.message}
 </p>
 <div className="ticket-footer">
 <span className="ticket-date">
 {new Date(ticket.createdAt).toLocaleString()}
 </span>
 <span className="ticket-action">View details →</span>
 </div>
 </div>
 );
 })}
 </div>
 )}
 </div>
 </main>
 </div>
 );
};

export default TicketHistory;
